import { MODEL_DIFF_DISPLAY_MODE, REPORTS_DIFF_AVAILABILITY } from './branchComparisonDetails/constants';
import type {
    BranchComparison,
    BranchData,
    ReportsDiffAvailability,
    ResolvedTableDiffType,
} from './branchComparisonDetails/types';

type EditToReviewSidesOptions<T> = {
    edit: T;
    review: T;
    viewerId: number | null;
    reviewOwnerId: number;
};

export function resolveEditToReviewSides<T>({
    edit,
    review,
    viewerId,
    reviewOwnerId,
}: EditToReviewSidesOptions<T>): { reference: T; target: T } {
    return viewerId === reviewOwnerId
        ? { reference: edit, target: review }
        : { reference: review, target: edit };
}

type BranchComparisonOptionsType = {
    tableDiff: ResolvedTableDiffType | null;
    referenceBranch: BranchData;
    targetBranch: BranchData;
    modelDetailsAvailable: boolean;
    reportsAvailable: boolean;
    reportsChangesPreviewAvailable?: boolean;
};

function resolveReportsDiffAvailability(
    tableDiff: ResolvedTableDiffType,
    reportsAvailable: boolean,
    reportsChangesPreviewAvailable: boolean,
): ReportsDiffAvailability {
    if (reportsAvailable) {
        return REPORTS_DIFF_AVAILABILITY.AVAILABLE;
    }
    if (!reportsChangesPreviewAvailable) {
        return REPORTS_DIFF_AVAILABILITY.UNAVAILABLE;
    }
    if (tableDiff.schemaDiff.diffs.length > 0) {
        return REPORTS_DIFF_AVAILABILITY.BLOCKED_BY_MODEL_DIFFS;
    }
    return REPORTS_DIFF_AVAILABILITY.REPORTS_CHANGES_PREVIEW;
}

export function buildBranchComparison({
    tableDiff,
    referenceBranch,
    targetBranch,
    modelDetailsAvailable,
    reportsAvailable,
    reportsChangesPreviewAvailable = false,
}: BranchComparisonOptionsType): BranchComparison | undefined {
    if (!tableDiff) {
        return undefined;
    }

    return {
        tableDiff,
        referenceBranch,
        targetBranch,
        modelDisplayMode: modelDetailsAvailable
            ? MODEL_DIFF_DISPLAY_MODE.DETAILED
            : MODEL_DIFF_DISPLAY_MODE.COUNT_ONLY,
        reportsAvailability: resolveReportsDiffAvailability(
            tableDiff,
            reportsAvailable,
            reportsChangesPreviewAvailable,
        ),
    };
}
